import { ReactNode } from 'react';
import {
  FullScreenContainer,
  FullScreenContent,
  FullScreenFooter,
  FullScreenPanel,
} from './FullScreen.styles';

type FullScreenProps = {
  rightSide: ReactNode | null;
  leftSide: ReactNode | null;
  footer?: ReactNode;
  hideOnSmallScreen?: 'right' | 'left';
};

export function FullScreen({ rightSide, leftSide, footer, hideOnSmallScreen }: FullScreenProps) {
  return (
    <FullScreenContainer direction="column">
      <FullScreenContent>
        {leftSide && (
          <FullScreenPanel hiddenOnSmallScreen={hideOnSmallScreen === 'left'}>
            {leftSide}
          </FullScreenPanel>
        )}
        {rightSide && (
          <FullScreenPanel hiddenOnSmallScreen={hideOnSmallScreen === 'right'}>
            {rightSide}
          </FullScreenPanel>
        )}
      </FullScreenContent>
      {footer && <FullScreenFooter>{footer}</FullScreenFooter>}
    </FullScreenContainer>
  );
}
